import { styled } from '@mui/material';

import WsColors from '../../WsColors';
import { Item } from '../Item';

export interface IWsChatBubbleProps {
  direction: 'INBOUND' | 'OUTBOUND';
}

const WsChatBubble = styled(Item)(({ direction }: IWsChatBubbleProps) => ({
  padding: 16,
  margin: 16,
  borderRadius: direction === 'OUTBOUND' ? '8px 8px 0 8px' : '8px 8px 8px 0',
  backgroundColor: direction === 'OUTBOUND' ? WsColors.BorderGrey : WsColors.TheBlues100,
  width: 'fit-content',
  maxWidth: 500,
}));

export default WsChatBubble;
